import PrepareToSendModal from './PrepareToSendModal';

export default PrepareToSendModal;
